import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext.js';

const topics = [
  { id: 'counting', label: 'Fundamental Principle of Counting' },
];

const ProbabilityPage = () => {
  const { isLight } = useTheme();
  const [activeSection, setActiveSection] = useState('counting');

  const scrollTo = (id) => {
    setActiveSection(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const accent = isLight ? '#5e19e6' : '#00f0ff';
  const textMain = isLight ? '#1a1a2e' : '#ffffff';
  const textMuted = isLight ? 'rgba(26,26,46,0.6)' : 'rgba(255,255,255,0.6)';
  const textFaint = isLight ? 'rgba(26,26,46,0.4)' : 'rgba(255,255,255,0.3)';

  return (
    <div className="min-h-screen pt-24 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 md:px-12">

        {/* Back Navigation */}
        <Link
          to="/resources"
          className={`inline-flex items-center gap-2 text-xs sm:text-sm font-mono uppercase tracking-widest transition-colors mb-8 sm:mb-12 ${
            isLight ? 'text-gray-400 hover:text-primary' : 'text-white/50 hover:text-accent'
          }`}
        >
          <span className="material-symbols-outlined text-sm">arrow_back</span>
          Back to Resources
        </Link>

        {/* Page header */}
        <div className="mb-10 sm:mb-14">
          <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <div
              className="w-1.5 h-1.5 rounded-full"
              style={{ backgroundColor: accent, boxShadow: `0 0 8px ${accent}` }}
            />
            <span
              className="text-[9px] sm:text-[10px] font-mono uppercase tracking-widest"
              style={{ color: accent }}
            >
              Resources
            </span>
          </div>

          <h1
            className="text-4xl sm:text-5xl md:text-6xl font-light tracking-tight leading-[1.1] mb-4"
            style={{ color: textMain }}
          >
            Probability
          </h1>
          <p
            className="text-base sm:text-lg font-light leading-relaxed max-w-[65ch]"
            style={{ color: textMuted }}
          >
            A structured introduction to probability theory and its foundations.
          </p>
        </div>

        {/* Layout: sidebar + content */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-12">

          {/* Sidebar */}
          <nav className="md:w-[240px] md:flex-shrink-0 md:sticky md:top-28 md:self-start md:max-h-[calc(100vh-8rem)] md:overflow-y-auto glass-panel rounded-xl p-4">
            <h3
              className="text-[10px] font-mono uppercase tracking-widest mb-4 px-2"
              style={{ color: textFaint }}
            >
              Topics
            </h3>
            <div className="flex flex-col gap-1">
              {topics.map((topic) => (
                <button
                  key={topic.id}
                  onClick={() => scrollTo(topic.id)}
                  className="text-left px-3 py-2.5 rounded-lg text-xs font-mono tracking-wide transition-all"
                  style={{
                    backgroundColor:
                      activeSection === topic.id
                        ? isLight ? 'rgba(94,25,230,0.1)' : 'rgba(0,240,255,0.1)'
                        : 'transparent',
                    color:
                      activeSection === topic.id
                        ? accent
                        : isLight ? 'rgba(26,26,46,0.6)' : 'rgba(255,255,255,0.5)',
                    borderLeft:
                      activeSection === topic.id
                        ? `2px solid ${accent}`
                        : '2px solid transparent',
                  }}
                >
                  {topic.label}
                </button>
              ))}
            </div>
          </nav>

          {/* Content */}
          <div className="flex-1 space-y-12">

            {/* Fundamental Principle of Counting */}
            <section id="counting">
              <div className="glass-panel rounded-xl p-6 sm:p-8 md:p-10">
                <h2
                  className="text-xl sm:text-2xl md:text-3xl font-light mb-4"
                  style={{ color: textMain }}
                >
                  Fundamental Principle of Counting
                </h2>
                <p style={{ color: textMuted }} className="leading-relaxed">
                  Content coming soon...
                </p>
              </div>
            </section>

          </div>
        </div>

      </div>
    </div>
  );
};

export default ProbabilityPage;
